
Vue.component('adminfactionPoints', {
    template: templates.adminfactionPoints,
    data() {
      return {
        model: {
            state: false,
            factionPoints: {
                faction: 0,
                nonFaction: 0,
                tournamentRound: 0,
                tournamentChampion: 0,
            },
            teamName: null,
        },
      };
    },
    mounted() {
      const c = this;
      c.get();
    },
 
    methods: {
        get() {
            const c = this;

            tournamentService.getActive()
            .then((res) => {
                if(res.data.status === 400){
                    
                    c.model.selectedTournament = []
                }
                else{
                   console.log(res)
                }
                  
          
           
            })
            .catch((error) => {
              // console.log(error);
            });
        },
        save(){
          const c = this;
        }
    }
     
  });
  